export const ConfigData = [
  {
    id: "name",
    name: "Campaign Name",
    isShow: true,
    width: "250px",
    filter: true,
  },
  {
    id: "description",
    name: "Campaign Description",
    isShow: true,
    width: "250px",
    filter: true,
  },
  {
    id: "created_on",
    name: "Created On",
    isShow: true,
    width: "160px",
    filter: true,
    format: "date-time"
  },
  {
    id: "button",
    name: "View Detail",
    type: "button",
    isShow: true,
    width: "117px"
    
  },
];


export const ConfigDataPredefinedTaskBased = [
  {
    id: "reward_name",
    name: "Reward Name",
    isShow: true,
    width: "160px",
    filter: true,
  },
  {
    id: "start_date",
    name: "Start Date",
    isShow: true,
    width: "100px",
    filter: true,
    format: "date-time"
  },
  {
    id: "end_date",
    name: "End Date",
    isShow: true,
    width: "100px",
    filter: true,
    format: "date-time"
  },
  {
    id: "point_cost",
    name: "points/coupon",
    isShow: true,
    width: "130px",
    filter: true,
  },
  {
    id: "total_quota",
    name: "Total Qty",
    isShow: true,
    width: "100px",
    filter: true,
  },
  {
    id: "provider_name",
    name: "Reward Partner",
    isShow: true,
    width: "100px",
    filter: true,
  },
  {
    id: "reward_value",
    name: "Reward Value",
    isShow: true,
    width: "100px",
    filter: true,
  },
  {
    id: "remaining_quota",
    name: "In-stock Quantity",
    isShow: true,
    width: "100px",
    filter: true,
  },
  {
    id: "created_by.name",
    name: "Created By",
    isShow: true,
    width: "160px",
    filter: true,
  },
  {
    id: "created_on",
    name: "Created On",
    isShow: true,
    width: "160px",
    filter: true,
    format: "date-time"
  },
  {
    id: "status",
    name: "Status",
    isShow: true,
    width: "160px",
    filter: true,
  },
  {
    id: "show_extend",
    name: "show_extend",
    isShow: false,
    width: "160px",
    filter: false,
  },
  {
    id: "button",
    name: "Action",
    type: "dropdown",
    isShow: true,
    width: "117px",
    action: ["View Details","Edit","Update Status","Delete","Extend"],
    permission: {
      ["Update Status"]: {
        id: "View Details",
        permission: ["gamifications.access_reward"]
      },
      ["Edit"]: {
        id: "Edit",
        permission: ["gamifications.access_reward"]
      },
      ["View Details"]: {
        id: "View Details",
        permission: ["gamifications.access_reward"]
      },
      ["Delete"]: {
        id: "Delete",
        permission: ["gamifications.access_reward"]

      },
      ["Extend"]: {
        id: "Extend",
        permission: ["gamifications.access_reward"]

      },
    },
    isshowAction: {
      item: "status",
      children: [
        {
          id: "Extend",
          value: "Extend",
          notShowCondition: 'Active',
        },
        {
          id: "Extend",
          value: "Extend",
          notShowCondition: 'Inactive',
        },
        {
          id: "Extend",
          value: "Extend",
          notShowCondition: 'Scheduled',
        },
        {
          id: "Extend",
          value: "Extend",
          notShowCondition: 'Extended',
        },
        {
          id: "Update Status",
          value: "Update Status",
          notShowCondition: 'Extended',
        },
        {
          id: "Update Status",
          value: "Update Status",
          notShowCondition: 'Expired',
        },
        {
          id: "Update Status",
          value: "Update Status",
          notShowCondition: 'Inactive',
        },
      ],
    },
  },
];

